import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles: string[];
    currentRole: string;
    loading: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    allowedRoles,
    currentRole,
    loading
}) => {
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600"></div>
            </div>
        );
    }

    if (!allowedRoles.includes(currentRole)) {
        // GUEST users (expired session, not logged in) → login page
        if (currentRole === 'GUEST') {
            return <Navigate to="/login" replace />;
        }
        // Authenticated users hitting wrong route → their home page
        const redirectPath = (currentRole === 'ADMIN' || currentRole === 'SUPER_ADMIN') ? '/admin' : '/dashboard';
        return <Navigate to={redirectPath} replace />;
    }

    return <>{children}</>;
};
